import png from './images/panthers.png'

export const colors = {
  dominant: '#231F20',
  highlight: '#fcb53e',
}
export const fullname = 'Panthers'
export const badge = png



// WEBPACK FOOTER //
// ./src/nrl-teams/panthers.js